// Кооператив игрока (E07-T06…T08): краткая карточка из bootstrap, полный кооператив с последней загрузки,
// мои заявки (GET /me/coop-requests, Р-87).
import { signal } from '@preact/signals';
import type { Api, ResponseOf } from '@garages/contract';
import { storage } from './storage.js';

export type Coop = ResponseOf<Api['getCoop']>;
export type CoopCard = ResponseOf<Api['listCoops']>['items'][number];
export type CoopRole = NonNullable<Coop['myRole']>;
export interface CoopBrief { coopId: string; name: string; role: CoopRole }

export const coopBrief = signal<CoopBrief | null>(null);
export const myCoop = signal<Coop | null>(null);

/** Заявок одновременно — не больше 5 (ux/07 §1); список — с сервера (Р-87). */
export const REQUESTS_MAX = 5;
const REJOIN_KEY = 'coopRejoinAt';

export type MyRequest = ResponseOf<Api['getMyCoopRequests']>['items'][number];
export const myRequests = signal<MyRequest[]>([]);

/** Перерыв после выхода (24 ч): сервер отдаёт rejoinAt в ответе leave и в REJOIN_COOLDOWN. */
export function rejoinAt(): number { return Number(storage.get(REJOIN_KEY) ?? 0); }
export function setRejoinAt(ms: number): void { storage.set(REJOIN_KEY, String(ms)); }

export function setMyCoop(c: Coop | null): void {
  myCoop.value = c;
  coopBrief.value = c && c.myRole ? { coopId: c.coopId, name: c.name, role: c.myRole } : null;
  if (c) myRequests.value = []; // приняли в один — остальные заявки отменяются (ux/07 §3)
}

/** Роль может: заявки, исключение, вызов босса, выбор постройки (ux/07 §0). */
export const isLeader = (r: CoopRole | null | undefined): boolean => r === 'chairman' || r === 'deputy';

/** Название кооператива (ux/07 §4): 3–20 символов — кириллица, латиница, цифры, пробел. */
export function nameProblem(name: string): 'short' | 'long' | 'chars' | null {
  const n = name.trim();
  if (n.length < 3) return 'short';
  if (n.length > 20) return 'long';
  if (!/^[\p{Script=Cyrillic}A-Za-z0-9 ]+$/u.test(n)) return 'chars';
  return null;
}

/** «Всё лишнее» (ux/07 §9): сдаём всё, кроме цены ближайшего своего улучшения. */
export function spareAmount(have: number, reserve: number): number { return Math.max(0, have - Math.max(0, reserve)); }
